import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { X } from "lucide-react"; // Import X icon for close button
import "./style.css";

const Navbar1 = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location]);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <h2 className="navbar-title" onClick={() => navigate("/")}>
          <span style={{color: "green"}} >on</span>COCHARTS
        </h2>
        <div className="navbar-menu">
          <Link
            to="/features"
            // target="_blank"
            className={`navbar-item ${
              activeTab === "/features" ? "active" : ""
            }`}
          >
            Features
          </Link>
          <Link
            to="/pricing"
            // target="_blank"
            className={`navbar-item ${
              activeTab === "/pricing" ? "active" : ""
            }`}
          >
            Subscriptions
          </Link>
          <Link
            to="/contact"
            className={`navbar-item ${
              activeTab === "/contact" ? "active" : ""
            }`}
          >
            Contact
          </Link>
        </div>
        <div className="navbar-hamburger" onClick={toggleDrawer}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div className={`navbar-drawer ${isDrawerOpen ? "open" : ""}`}>
        <div className="drawer-header">
          <button onClick={closeDrawer} className="close-button">
            <X size={24} />
          </button>
        </div>
        <div className="navbar-drawer-content">
          <Link
            to="/features"
            className={`navbar-item ${
              activeTab === "/features" ? "active" : ""
            }`}
            onClick={closeDrawer}
          >
            Features
          </Link>
          <Link
            to="/pricing"
            className={`navbar-item ${
              activeTab === "/pricing" ? "active" : ""
            }`}
            onClick={closeDrawer}
          >
            Subscriptions
          </Link>
          <Link
            to="/contact"
            className={`navbar-item ${
              activeTab === "/contact" ? "active" : ""
            }`}
            onClick={closeDrawer}
          >
            Contact
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar1;
